module.exports = "pegasus/assets/blocks/column-lp9-basic.png";